import React from 'react';
import config from 'config';
import { connect } from 'react-redux';

import { withRouter } from "react-router-dom";
import { Row, Col, Nav, NavItem, Tab, Table } from "react-bootstrap";
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

//APIs
import appRouter from '../../utils/appRouter';
import GameApi from '../../api/game-api';
import UserApi from '../../api/user-api';
import ModalApi from '../../api/modal-api';

let SHOW_ITEMS = 'showItems';

class TicketPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			tabs: [],
			totalOfQuestions: 0,
			totalOfTickets: GameApi.countTickets(this.props.user.game),
			percentOfCorrectQuestions: '0%',
			averageCupons: '0%'
		};

		this.sortArray = this.sortArray.bind(this);
		this.loadMore = this.loadMore.bind(this);
		this.openTicketModal = this.openTicketModal.bind(this);
		this.createTabsAndTable = this.createTabsAndTable.bind(this);
		this.setTotalCorrectQuestions = this.setTotalCorrectQuestions.bind(this);
		this.calcPercent = this.calcPercent.bind(this);
	}

	sortArray(property, array) {
		property = property.split('.');
		let l = property.length;

		return array.sort((a, b) => {
			let i = 0;
			while (i < l) {
				a = a[property[i]];
				b = b[property[i]];
				i++;
			}
			return a < b ? -1 : 1;
		});
	}

	loadMore(tab, origin) {
		tab.rows[SHOW_ITEMS][origin] += config.application.ticketPaginationCount;
		this.forceUpdate();
	}

	openTicketModal(period, origin) {

		let description = <FormattedHTMLMessage id="ticket.modal.description" values={{
			validityStart: period.dates.validityStart,
			validityEnd: period.dates.validityEnd,
		}} />;

		let codes = [];

		for (let ticket of period.tickets[origin]) {
			let code = config.application.ticketSize[period.type].slice(0, -(ticket.number.toString().length)) + ticket.number.toString();
			codes.push(code);
		}

		//** NOTE **
		// This function inside .sort() organizes the numbers with more precision.
		// if not used, sort will considerate 4 greater than 10, because only the first character will be considered.
		codes = codes.sort((a, b) => {
			return a - b
		}).join(', ');

		let descriptionFull = <div className="text-left">{description}<br /><br />{codes}</div>;

		ModalApi.showModal({
			title: <FormattedHTMLMessage id="ticket.modal.title" />,
			description: descriptionFull,
			buttons: []
		})
	}

	createTabsAndTable() {
		let tabs = [];
		let ticketPeriods = this.props.ticket.periods;

		for (let ticketTab of this.props.ticket.ticketTypes) {
		let count = 0;
		let ticketPeriodsTypes = ticketPeriods ? ticketPeriods['MONTHLY'] : []//ticketPeriods[ticketTab];

		if (ticketPeriodsTypes) {
			for (let ticketsArr of ticketPeriodsTypes) {
				count += ticketsArr.count;
			}
		}

		let title = <FormattedMessage id={'ticket.tabs.' + 'MONTHLY'} values={{
			ticketsCount: count
		}} />;

		let rows = {};
		let origins = [];

		if (ticketPeriodsTypes) {
			for (let period of ticketPeriodsTypes) {
				let i = 0;
				for (let origin of config.application.ticketOrigins) {
					if (!period.tickets[origin]) continue;

					if (!rows[origin]) {
						origins.push(origin);
						rows[origin] = [];

						if (!rows[SHOW_ITEMS]) rows[SHOW_ITEMS] = {};
						rows[SHOW_ITEMS][origin] = config.application.ticketPaginationCount;
					}

					rows[origin].push({ period, origin });
					i++;
				}
			}
		}

		for (let origin of config.application.ticketOrigins) {
			if (rows[origin]) {
				this.sortArray('period.msTime', rows[origin]);
				rows[origin] = rows[origin].reverse();
			}
		}

		tabs.push({ title, rows, origins });
		}

		//return tabs;
		this.setState({ tabs: tabs })
	}

	calcPercent(number, number2) {
		let percentResolve = parseInt(((number * 100) / number2));
		percentResolve = (percentResolve) ? percentResolve : 0;

		let percentResolveString = percentResolve.toString();
		return percentResolveString + '%';
	}

	setTotalCorrectQuestions() {
		let totalOfQuestions = (this.props.user.game.answeredQuestions) ? this.props.user.game.answeredQuestions.length : 0;

		let totalOfCorrectQuestions = 0;
		for (let i = 0; i < totalOfQuestions; i++) {
			let correctAnswerNum = (this.props.user.game.answeredQuestions[i].channel == "WEB") ?
				this.props.user.game.answeredQuestions[i].correctAnswerWebNum :
				this.props.user.game.answeredQuestions[i].correctAnswerNum;

			if (this.props.user.game.answeredQuestions[i].answer === correctAnswerNum)
				totalOfCorrectQuestions++;
		}

		return this.calcPercent(totalOfCorrectQuestions, totalOfQuestions);
	}

	componentDidMount() {
		this.createTabsAndTable();
	}

	componentWillMount() {
		
		if (!this.props.user.msisdn) {
			return this.props.history.push(appRouter.getLink('home'), {
				scrollY: config.application.homeScrollToFormTime
			});
		}

		UserApi.getUser(this.props.user.msisdn).then(user => {

			let hasTicket = GameApi.countTickets(this.props.user.game);
			console.log(user);
			
			if (hasTicket == 0) {
				/* Essa mecânica foi removida para que o usuário não retorne à home
				 this.props.history.push(appRouter.getLink('home'), {
					scrollY: config.application.homeScrollToFormTime
				}); */
			}
		});
	}

	render() {
		if (!this.props.user.msisdn) return (<div />);

		let rows;

		let tabs = this.state.tabs;
		let totalOfQuestions = (this.props.user.game.answeredQuestions) ? this.props.user.game.answeredQuestions.length : 0;
		let totalOfTickets = GameApi.countTickets(this.props.user.game);
		let percentOfCorrectQuestions;
		let averageCupons = percentOfCorrectQuestions = this.setTotalCorrectQuestions();

		let correctStyle = {
			width: percentOfCorrectQuestions,
			WebkitTransition: 'width 2s'
		};
		let averageCuponsStyle = {
			width: averageCupons,
			WebkitTransition: 'width 2s'
		};

		return (
			<div className="panel-page-internal">
				<div className="bg-red-horizontal shadow">
					<div className="container-secondary text-white">
						<Col md={12}>
							<div className="row-mobile">
								<h1 className="text-bold"><FormattedMessage id="ticket.page.title" /></h1>
								<h2 className="text-light"><FormattedMessage id="ticket.page.description" /></h2>
							</div>
						</Col>
					</div>
				</div>

				{/* <div className="container-flex bg-white">					
					<Col md={12}>
						<div className="ticket-performance">
							<p><FormattedMessage id="ticket.performance.title"/></p>
							<div className="box-performance">
								<p className="description">Taxa de Acerto</p>

								<div className="porcent">
									{percentOfCorrectQuestions}
								</div>
								<div className="process-container">
									<p>
										<FormattedMessage id="ticket.performance.of"/>
										{totalOfQuestions}
										<FormattedMessage id="ticket.performance.answeredQuestions"/>
									</p>

									<div className="bar">
										<div className="bar-process" style={correctStyle}></div>
									</div>										
								</div>																			
							</div>

							<div className="box-performance">
								<p className="description">Média de Cupons</p>
								<div className="porcent">
									{totalOfTickets}
								</div>
								<div className="process-container">
									<p>
										<FormattedMessage id="ticket.performance.per"/>
										{totalOfQuestions}
										<FormattedMessage id="ticket.performance.answeredQuestions"/>
									</p>

									<div className="bar">
										<div className="bar-process" style={averageCuponsStyle}></div>
									</div>
								</div>
							</div>
						</div>
					</Col>
		</div> */}

				<div className="container-flex">
					<div className="ticket-content bg-white">
						<Tab.Container defaultActiveKey={0} id="ticket-tabs">
							{this.props.user.game.monthlyTickets.length > 0 ? 
							<Col sm={12}>

								<div className="ticket-tabs">
									<Nav bsStyle="tabs">
										{tabs && tabs.map((item, i) =>
											<NavItem key={i} eventKey={i}>
												{item.title}
											</NavItem>
										)}
									</Nav>
								</div>

								<div className="ticket-grid">
									<Tab.Content animation>
										{
											tabs.map((tab, i) =>
												<Tab.Pane key={"tabs" + i} eventKey={i}>
													{
														tab.origins.map((origin, j) =>
															<Table key={"origin" + j} responsive className="table-customizer">
																<thead>
																	<tr>
																		<th>
																			<FormattedMessage id="ticket.table.header.period" />
																		</th>
																		<th>
																			<FormattedMessage id="ticket.table.header.lottery" />
																		</th>
																		<th>
																			<FormattedMessage id={"ticket.table.header.tickets." + origin} />
																		</th>
																	</tr>
																</thead>
																<tbody>
																	{((tab.rows[SHOW_ITEMS][origin] < tab.rows[origin].length) ? rows = tab.rows[origin].slice(0, tab.rows[SHOW_ITEMS][origin]) : rows = tab.rows[origin]) &&
																		rows.map((ticket, k) =>
																			<tr key={k}>
																				<td width="40%">
																					<FormattedHTMLMessage id="ticket.table.body.period" values={{
																						validityStart: ticket.period.dates.validityStart,
																						validityEnd: ticket.period.dates.validityEnd,
																					}} />
																				</td>
																				<td width="20%">
																					{ticket.period.dates.lotteryDay}
																				</td>
																				<td width="40%" className={'ticket-count'} onClick={() => {
																					this.openTicketModal(ticket.period, origin)
																				}}>
																					{ticket.period.countOrigin[origin]}
																				</td>
																			</tr>
																		)}
																	{(tab.rows[SHOW_ITEMS][origin] < tab.rows[origin].length) &&
																		<tr>
																			<td colSpan={3} className="more text-bold" onClick={() => {
																				this.loadMore(tab, origin)
																			}}>
																				<a>
																					<FormattedMessage id="btn.seeMore" />
																				</a>
																				{/*More {tab.rows[origin].length - rows.length}*/}
																			</td>
																		</tr>
																	}
																</tbody>
															</Table>
														)
													}
												</Tab.Pane>
											)
										}
									</Tab.Content>
								</div>
							</Col> : <Col sm={12}>
								<div className='container-flex panel-offer logged text-center'>
									<div className="col-md-12">
										<h2>Você ainda não tem cupons</h2>
									</div>
								</div>
								</Col>}
						</Tab.Container>

					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = function (store) {
	return {
		user: store.userState,
		ticket: store.ticketState
	};
};

export default withRouter(connect(mapStateToProps)(TicketPage));


// WEBPACK FOOTER //
// ./src/components/pages/ticket.component.jsx